import axios from "axios";
import React, { useState, useEffect } from "react";
import { CiCircleChevLeft, CiCircleChevRight } from "react-icons/ci";
import Cookies from "universal-cookie";
import moment from "moment";
import { useNotification } from "./NotificationContext";
import { ExclamationCircleIcon } from "@heroicons/react/solid";
import { BellIcon } from "@heroicons/react/outline";
import { LendingModal } from "../widgets/LendingModal";
import { base_url } from "../api/Axios";
import EditOwner from "./EditOwner";
import Loader from "./Loader";
import Logout from "./Logout";
import { useNavigate } from "react-router-dom";

export class SearchParams {
	first = 0;
	rows = 10;
	searchText = "";
	sortColumn = "";
	sortDirection = 1;
}

const DisapprovedOwnerList = () => {
	const { updateDisapprovedCount } = useNotification();
	const cookies = new Cookies();
	const navigate = useNavigate();
	const token = cookies.get("token");
	const [owner, setOwner] = useState(null);
	const [fetchOwnerError, setFetchOwnerError] = useState();
	const [selectedOwner, setSelectedOwner] = useState(null);
	const [url, setUrl] = useState(null);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [detailDataChecker, setDetailDataCheker] = useState();
	const parts = url?.split("/");
	const subUrl = parts?.slice(-3).join("/");
	const [searchParams, setSearchParams] = useState(new SearchParams());
	const [disapprovedCount, setDisapprovedCount] = useState(0);
	const [loading, setLoading] = useState(false);

	const [ownerForm, setOwnerForm] = useState({
		first_name: "",
		middle_name: "",
		last_name: "",
		phone: "",
		gender: "",
		martial_status: "",
		minimum_monthly_income: "",
		average_daily_income: "",
		account_number: "",

		ownership_number: "",
		chassis_number: "",
		engine_number: "",
		plate_number: "",

		vehicle_make: "",
		year_of_make_date: "",
		ownership_certificate: null,
		remark: "",
	});

	useEffect(() => {
		const fetchDetailData = async () => {
			try {
				const response = await axios.get(`${base_url}${subUrl}`, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});

				setDetailDataCheker(response.data);
				console.log("Detail Data Checker", detailDataChecker);
				setOwnerForm({
					first_name: response.data.first_name,
					middle_name: response.data.middle_name,
					last_name: response.data.last_name,
					phone: response.data.phone,
					gender: response.data.gender,
					martial_status: response.data.martial_status,

					minimum_monthly_income: response.data.minimum_monthly_income,
					average_daily_income: response.data.average_daily_income,
					account_number: response.data.account_number,
					ownership_number: response.data.ownership_number,
					chassis_number: response.data.chassis_number,
					engine_number: response.data.engine_number,
					plate_number: response.data.plate_number,
					vehicle_make: response.data.vehicle_make,
					year_of_make_date: response.data.year_of_make_date,
					ownership_certificate: response.data.ownership_certificate,
				});
			} catch (error) {
				if (error?.response?.status === 401) {
					Logout();

					setTimeout(() => {}, 2000);
					navigate("/login");
				}
				console.log(error);
			}
		};

		fetchDetailData();
	}, [subUrl]);

	const openModal = (ownerName, url) => {
		setSelectedOwner(ownerName);
		setUrl(url);
		setModalIsOpen(true);
	};

	const closeModal = () => {
		setModalIsOpen(false);
	};

	useEffect(() => {
		const fetchOwner = async () => {
			setLoading(true);
			try {
				const response = await axios.get(
					`${base_url}vehicles/?f=${searchParams.first}&limit=${searchParams.rows}&offset=${searchParams.first}&status=DISAPPROVED`,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				);
				setOwner(response.data);
				setDisapprovedCount(response.data.count);
				updateDisapprovedCount(response.data.count);
				setLoading(false);
			} catch (error) {
				if (error?.response?.status === 401) {
					Logout();
					setFetchOwnerError(error?.response?.data[0]);
					setTimeout(() => {
						setFetchOwnerError("");
					}, 2000);
					navigate("/login");
				}
				setFetchOwnerError(error?.response?.data[0]);
				setLoading(false);
				console.error("Error fetching owner data:", fetchOwnerError);
			}
		};

		fetchOwner();
	}, [searchParams, modalIsOpen]); // Empty dependency array means this effect runs once on mount

	// console.log(fetchOwnerError);
	const displayOwner =
		owner?.results?.map((ownerList, index) => ({
			url: ownerList?.url,
			created: ownerList?.created_at,
			name:
				ownerList?.first_name +
				" " +
				ownerList?.middle_name +
				" " +
				ownerList?.last_name,
			phone: ownerList?.phone,
			status: ownerList?.status,
		})) || null;
	const goNext = () => {
		if (searchParams.first + searchParams.rows < owner.count) {
			setSearchParams({
				...searchParams,
				first: searchParams.first + searchParams.rows,
			});
		}
	};

	const goBack = () => {
		if (searchParams.first > 0) {
			setSearchParams({
				...searchParams,
				first: searchParams.first - searchParams.rows,
			});
		}
	};
	return (
		<>
			<div className="min-h-[50vh] flex flex-col justify-center items-center">
				{loading && <Loader />}
				{fetchOwnerError ? (
					<div>Error fetching owner data. Please try Agian.</div>
				) : owner?.count > 0 ? (
					<div className="overflow-x-auto w-full py-8 px-2">
						<table className="min-w-full  border-gray-300">
							<thead>
								<tr className="text-left">
									<th className="py-2 px-4 border-b">No.</th>
									<th className="py-2 px-4 border-b">Created</th>
									<th className="py-2 px-4 border-b">Name</th>
									<th className="py-2 px-4 border-b">Phone</th>
									<th className="py-2 px-4 border-b">Status</th>
									<th className="py-2 px-4 border-b">Change</th>
								</tr>
							</thead>
							<tbody className="align-center text-left">
								{displayOwner?.map((ownerInfo, index) => (
									<tr
										key={index}
										className={index % 2 === 0 ? "bg-gray-100" : ""}
									>
										<td className="py-2 px-4 border-b">
											{searchParams.first + index + 1}
										</td>
										<td className="py-2 px-4 border-b">
											{ownerInfo?.created
												? moment(ownerInfo?.created).format("YYYY-MM-DD")
												: ""}
										</td>
										<td className=" py-2 px-4 border-b">{ownerInfo?.name}</td>
										<td className="py-2 px-4 border-b">{ownerInfo?.phone}</td>
										{/* <td className="py-2 px-4 border-b">
											{ownerInfo?.ownership_certificate}
										</td> */}

										<td className="py-2 px-4 border-b">{ownerInfo?.status}</td>
										<td className="py-2 px-4 border-b">
											<button
												onClick={() =>
													openModal(
														ownerInfo?.name ? ownerInfo?.name : "Anonymous",
														ownerInfo?.url
													)
												}
												className="bg-kacha-orange-700 hover:bg-kacha-orange-600 text-white font-bold py-2 px-4 rounded"
											>
												Edit
											</button>
										</td>
									</tr>
								))}
							</tbody>
						</table>
						{selectedOwner && (
							<EditOwner
								isOpen={modalIsOpen}
								closeModal={closeModal}
								reviewData={detailDataChecker}
								dataTobeUpdated={ownerForm}
								setOwnerForm={setOwnerForm}
								sub_url={subUrl}
							/>
						)}
					</div>
				) : (
					<div className="flex flex-col justify-center items-center">
						<div className="flex flex-col justify-center items-center">
							<ExclamationCircleIcon className="h-10 w-10 text-orange-500" />
							<div className="text-gray-500 text-lg font-bold">
								No Disapproved Owner Found
							</div>
						</div>
					</div>
				)}
				{owner?.count > 0 && (
					<div className="flex items-center  justify-between w-md">
						<div className="flex items-center space-x-2">
							<span className="text-gray-600">Items per page: </span>
							<div className="relative inline-block">
								<select
									className="block appearance-none w-full bg-white border border-gray-300 text-gray-700 py-2 px-4 pr-8 rounded-md leading-tight focus:outline-none focus:border-blue-500 focus:bg-white"
									value={searchParams.rows}
									onChange={(e) => {
										searchParams.rows = Number(e.target.value);
										setSearchParams({ ...searchParams });
									}}
								>
									<option value="10"> 10</option>
									<option value="20">20</option>
									<option value="50">50</option>
								</select>
								<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
									<svg
										className="fill-current h-4 w-4"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
									>
										<path d="M10 12.5l-5-5 1.5-1.5L10 9.5l3.5-3.5L15 7z" />
									</svg>
								</div>
							</div>
						</div>

						<span className="text-gray-600 px-10">
							{searchParams.first + 1} -{" "}
							{searchParams.first + searchParams.rows} of {owner?.count || 0}
						</span>

						<div className="flex items-center space-x-4">
							<div onClick={goBack}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className={`${
										searchParams.first === 0
											? "opacity-50 cursor-not-allowed"
											: ""
									}  h-8 w-8 text-orange-700 font-bold`}
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M15 19l-7-7 7-7"
									/>
								</svg>{" "}
							</div>
							<div onClick={goNext} className="">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className={`${
										searchParams.first + searchParams.rows >= owner?.count
											? "opacity-50 cursor-not-allowed"
											: ""
									}  h-8 w-8  text-orange-700  font-bold`}
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M9 5l7 7-7 7"
									/>
								</svg>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default DisapprovedOwnerList;
